import React, { Component } from "react";

import LittleSquirtsImg from "../../assets/images/ministries/LittleSquirts.jpg";

class LittleSquirts extends Component {
	render() {
		return (
			<section>
				<header id="page-title">
					<div className="container">
						<h1>Little Squirts</h1>
					</div>
				</header>
				<section className="container">
					<img src={LittleSquirtsImg} className="img img-responsive" style={{ float: "right", padding: 10 }} alt="" />
					<p className="lead">Wednesdays 10-11:30am, from February 15th 2023</p>
					<p>
						Little Squirts welcomes parents and carers with children under 5. Each week we have great fun with singing,
						dancing, instruments, story time, toys and craft. This is a great weekly activity that you kids can still
						enjoy. It is engaging, fun and creative.
						<br />
						<br />
						We love to care for parents and carers, too. Enjoy a coffee, a tasty home-baked treat and conversation.
						<br />
						<br />
						<strong>**We are back to our church building after an exciting renovation!**</strong>
						<br />
						<br />
						<strong>Date:</strong> WEDNESDAYS
						<br />
						<strong>Venue:</strong>Kingston Christian Reformed (Upstairs)
						<br />
						<strong>Address:</strong> 17 Denison Street, Kingston
						<br />
						<strong>Parking:</strong> Private parking on Denison Street
						<br />
						<br />
						To keep up to date with what's happening like us on Facebook at{" "}
						<a href="https://www.facebook.com/littlesquirtskingston/" target="_blank" rel="noopener noreferrer">
							Little Squirts Playgroup Kingston
						</a>
						. Our page is updated weekly.
						<br />
						<br />
						For our COVID19 safe measure please see our{" "}
						<a href="https://www.facebook.com/littlesquirtskingston/" target="_blank" rel="noopener noreferrer">
							facebook page
						</a>
						.
					</p>

					<p>
						For more information contact Julia King at{" "}
						<a href="mailto:juliacking@googlemail.com">juliacking@googlemail.com</a>
					</p>
				</section>
			</section>
		);
	}
}

export default LittleSquirts;
